"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitPrefetchingMetrics = exports.prefetchNextSpotlightSnaps = void 0;
const media_1 = require("./media");
const web_graphene_reporting_1 = require("@snapchat/web-graphene-reporting");
const web_log_1 = require("@snapchat/web-log");
const SPOTLIGHT_PREFETCHING_LOOK_AHEAD = 3;
const prefetchNextSpotlightSnaps = async (index, spotlightStories, onUpdateSpotlightStories, feedRegistry) => {
    let indexToFetch = index + 1;
    const snapsToPrefetch = [];
    while (indexToFetch >= 0 &&
        indexToFetch < spotlightStories.length &&
        indexToFetch <= index + SPOTLIGHT_PREFETCHING_LOOK_AHEAD) {
        const story = spotlightStories[indexToFetch];
        const storyId = story.story?.storyId?.value || "";
        const mediaUrl = story.story?.snapList[0].snapUrls?.mediaUrl;
        // eslint-disable-next-line
        if (feedRegistry && !feedRegistry[storyId]) {
            snapsToPrefetch.push({
                index: indexToFetch,
                storyId: story.story?.storyId?.value || "",
                mediaUrl: mediaUrl,
                previewUrl: story.story?.snapList[0].snapUrls?.mediaPreviewUrl?.value,
            });
        }
        indexToFetch++;
    }
    return (0, media_1.prefetchSnaps)(snapsToPrefetch).then((prefetchedSnaps) => {
        // if prefetch has failed for a snap, remove it from spotlight stories
        const storiesToFilter = prefetchedSnaps
            .filter((prefetchedSnap) => prefetchedSnap.errors !== undefined)
            .map((prefetchedSnap) => prefetchedSnap.snapId);
        if (storiesToFilter.length > 0) {
            web_log_1.log.error("Could not prefetch: ", storiesToFilter);
            onUpdateSpotlightStories(storiesToFilter);
        }
        const fetchedSnaps = prefetchedSnaps.filter((prefetchedSnap) => prefetchedSnap.errors === undefined);
        void (0, web_graphene_reporting_1.reportHistogram)("Prefetching.Filtering.SnapsWithErrors", prefetchedSnaps.length - fetchedSnaps.length);
        return fetchedSnaps;
    });
};
exports.prefetchNextSpotlightSnaps = prefetchNextSpotlightSnaps;
const emitPrefetchingMetrics = (pageName, isMobile, snap) => {
    const device = isMobile ? "Mobile" : "Desktop";
    if (snap) {
        void (0, web_graphene_reporting_1.incrementCounter)(`${pageName}.${device}.SnapMedia.Success`);
    }
    else {
        void (0, web_graphene_reporting_1.incrementCounter)(`${pageName}.${device}.SnapMedia.Failure`);
    }
};
exports.emitPrefetchingMetrics = emitPrefetchingMetrics;
//# sourceMappingURL=prefetching.js.map